import { render, staticRenderFns } from "./CaseImages.vue?vue&type=template&id=2724f1dc&"
import script from "./CaseImages.vue?vue&type=script&lang=ts&setup=true&"
export * from "./CaseImages.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2724f1dc')) {
      api.createRecord('2724f1dc', component.options)
    } else {
      api.reload('2724f1dc', component.options)
    }
    module.hot.accept("./CaseImages.vue?vue&type=template&id=2724f1dc&", function () {
      api.rerender('2724f1dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorCases/components/CaseImages.vue"
export default component.exports